import { render, staticRenderFns } from "./ProductsReportList.vue?vue&type=template&id=65b21e2a&"
import script from "./ProductsReportList.vue?vue&type=script&lang=js&"
export * from "./ProductsReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports